import React, { useEffect, useState } from "react"
import { enumUtil } from "../../../../utils/Enum"
import FormValidator from "../../../../utils/FormValidator"
import { ServerRequestProtected } from "../../../../utils/ServerDataRequest"
import NotificationHandler from "../../../../utils/NotificationHandler"
import isNull from "../../../../utils/NullChecking"
import Loader from "../../../shared/Loader/Loader"
import Modal from 'react-bootstrap/Modal';
import DeleteConfirmatiom from "../../../General/DeleteConfirmation"
import Audit from "../../../General/Audit"
import ModalHeader from "../../Shared/ModalHeader"
import ModalFooter from "../../Shared/ModalFooter"
import { FindSecondChild } from "../../../../utils/FindMenuOption"
const AddNewRevenueCodes = (props) => {
    let IsEditAllowed = FindSecondChild('Setup', 'Codes', 'Revenue')?.IsAdd
    let IsDeleteAllowed = FindSecondChild('Setup', 'Codes', 'Revenue')?.IsDeleted
    let valModal = {}
    let ValidationModal = {
        RevenueCodeVal: "",
    }

    let Revenue_Modal = {
        RevenueCode: null,
        Description: "",
        FullDescription: "",
        UpdatedDate: "",
        UpdatedBy: "",
        SeparateBillable: '',
    }
    const [RevenueCodes, setRevenueCodes] = useState()
    const [RevenueValidationModal, setRevenueValidationModal] = useState(ValidationModal)
    const [RevenueSaveUpdateModal, setRevenueSaveUpdateModal] = useState({})
    const [mainRevenueModal, setmainRevenueModal] = useState(Revenue_Modal);
    const [isLoading, setIsLoading] = useState(false)
    const [del, setDel] = useState(false)
    const [isOpenAlert, setisOpenAlert] = useState(false);
    const API_URL = enumUtil.controller.General
    const { isOpenRevenue, onClose, onDeleteRevenue, type, isOpenFromList, handleSelectRevenueCode } = { ...props }
    const [onRevenueSave, setOnRevenueSave] = useState(false)
    const [isOpenAudit, setisOpenAudit] = useState(false);

    useEffect(() => {
        if (props.RevenueCode != null && !isOpenFromList) {
            setRevenueCodes(props.RevenueCode)
            setDel(true);
        } else {
            if (!onRevenueSave) {
                setRevenueCodes(0);
                setDel(false);
            } else {
                setDel(true);
            }
        }

    }, [])
    useEffect(() => {

        if (!isNull(RevenueCodes) && !isOpenFromList) {
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/FindByID", 'post', {
                "ID": RevenueCodes,
                "TableName": enumUtil.enumAPITableName.RevenueCode

            }).then((response) => {
                setIsLoading(false)
                setmainRevenueModal(response)
                // setPracticeID(response.PracticeID)
            }).catch((error) => {
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                setIsLoading(false)
            })
        }
    }, [RevenueCodes])
    useEffect(() => {
        setmainRevenueModal({ ...mainRevenueModal, RevenueCode: props.RevenueCode })
        setRevenueSaveUpdateModal({ ...RevenueSaveUpdateModal, RevenueCode: props.RevenueCode })
    }, [isOpenFromList])


    const handleRevenueChange = (e) => {
        let { name, value } = e.target;
        if (process.env.REACT_APP_ISUPPERCASE === "true") {
            value = value.toUpperCase()
        }
        let modal = { ...mainRevenueModal };
        let saveModal = { ...RevenueSaveUpdateModal }
        if (name === "SeparateBillable") {
            modal[name] = !modal[name]
        } else {
            modal[name] = value

        }
        setmainRevenueModal(modal)
        for (var property in Revenue_Modal) {
            if (name === property) {
                if (name === "SeparateBillable") {
                    saveModal[name] = modal[name] + ""
                } else {
                    saveModal[name] = value
                }
            }
        }
        setRevenueSaveUpdateModal(saveModal)
    }
    const RevenueValidation = async () => {
        let ValidationModal = {
            RevenueCodeVal: FormValidator(
                mainRevenueModal.RevenueCode,
                enumUtil.enumValidationType.Required,
                'Revenue Code',
            )
        }
        await setRevenueValidationModal(ValidationModal)
        valModal = ValidationModal
    }
    const handleSaveRevenue = async () => {
        setRevenueCodes(mainRevenueModal.RevenueCode)
        setRevenueCodes(RevenueCodes)
        await RevenueValidation()
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (validation) {
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        } else {
            setRevenueSaveUpdateModal(RevenueSaveUpdateModal)
            let saveModal = {
                TableName: enumUtil.enumAPITableName.RevenueCode,
                ID: RevenueCodes,
                data: { ...RevenueSaveUpdateModal },
                value: null
            }
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/SaveSingleRecord", 'post', saveModal)
                .then((response) => {
                    if (!isNull(response.id)) {
                        setIsLoading(false)
                        onDeleteRevenue()
                        NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success)
                        handleSelectRevenueCode({ display: mainRevenueModal.RevenueCode, value: response.id })
                        setRevenueCodes(response.id)
                        setOnRevenueSave(true)
                    }
                }).catch((error) => {
                    setIsLoading(false)
                    NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                })
        }
    }
    const SetRevenueName = () => {
        if (mainRevenueModal.RevenueCode != null && mainRevenueModal.RevenueCode != "") {
            return (
                <p className="heading">{mainRevenueModal.RevenueCode}</p>
            )
        } else {
            return (
                <p className="heading">Add New Revenue Code</p>
            )
        }
    }
    const handleDeleteModal = () => {
        setisOpenAlert(true)
    }
    const onCloseDelete = () => {
        setisOpenAlert(false)
    }
    let DeletePopup = ""
    if (del) {
        DeletePopup = <button className={IsDeleteAllowed === false ? 'btn-icon-transparent delete-btn-disabled' : 'btn-icon-transparent '} onClick={handleDeleteModal}><span className="icon"><i className="icon-delete"></i></span><span className="title">Delete</span></button>
    }
    let DeleteConfirmation = "";
    if (isOpenAlert) {
        DeleteConfirmation = <DeleteConfirmatiom isOpenAlert={isOpenAlert} onCloseDelete={onCloseDelete} API_URL={API_URL} TableName={enumUtil.enumAPITableName.RevenueCode} ID={RevenueCodes} onClose={onDeleteRevenue} />
    }
    const handleAuditModal = () => {
        setisOpenAudit(true)
    }
    const onCloseAudit = () => {
        setisOpenAudit(false)
    }
    let AuditPopup = "";
    if (isOpenAudit) {
        AuditPopup = <Audit isOpenAudit={isOpenAudit} onCloseAudit={onCloseAudit} ParentID={RevenueCodes + ""} TableName={enumUtil.enumAPITableName.RevenueCode} />
    }
    const AddNewRevenueCodesModalBody = () => {
        return (
            <>
                {isLoading ? <Loader /> : null}
                <div>
                    <div className="form-group input">
                        <label htmlFor="RevenueCode">Revenue Code<span className='req'>*</span></label>
                        <div className={RevenueValidationModal.RevenueCodeVal ? 'form-group input error' : 'form-group input'}>
                            <input type="text"
                                className='form-control'
                                name="RevenueCode"
                                id="RevenueCode"
                                autoComplete="off"
                                value={mainRevenueModal.RevenueCode}
                                onChange={handleRevenueChange}
                            />
                            {RevenueValidationModal.RevenueCodeVal}
                        </div>
                        {/* error helperText="Error Message" */}
                    </div>
                    <div className='form-group input'>
                        <label htmlFor="Description">Description</label>
                        <input type="text"
                            className='form-control'
                            name="Description"
                            id="Description"
                            autoComplete="off"
                            value={mainRevenueModal.Description}
                            onChange={handleRevenueChange}
                        />
                    </div>
                    <div className='form-group input'>
                        <label htmlFor="FullDescription">FullDescription</label>
                        <textarea type="text"
                            rows={5}
                            className='form-control'
                            name="FullDescription"
                            id="FullDescription"
                            value={mainRevenueModal.FullDescription}
                            onChange={handleRevenueChange}
                        />
                    </div>
                    <div className='form-group input'>
                        <div className="d-flex gap-1 align-items-center">
                            <input
                                className="form-check-input p-0 mt-0"
                                type="checkbox"
                                id="SeparateBillable"
                                name="SeparateBillable"
                                autoComplete="off"
                                checked={mainRevenueModal.SeparateBillable}
                                onChange={(e) => handleRevenueChange(e)}
                            />
                            <label className="form-check-label heading font-m" for="SeparateBillable">
                                Separate Billable
                            </label>
                        </div>
                    </div>
                </div>
            </>
        )
    }

    return (
        <React.Fragment>
            {DeleteConfirmation}
            {type && type === "Wizard" ?
                <>
                    {AuditPopup}
                    {AddNewRevenueCodesModalBody()}
                    <ModalFooter isSaved={onRevenueSave ? onDeleteRevenue : onClose} handleSave={handleSaveRevenue} UpdatedDate={mainRevenueModal.UpdatedDate} UpdatedBy={mainRevenueModal.UpdatedBy} ID={RevenueCodes} IsEditAllowed={IsEditAllowed} />

                </> :
                <Modal show={isOpenRevenue} onHide={onClose} backdrop="static" keyboard={false} centered dialogClassName="app-modal hk-modal-v1 ar-small-modal">
                    {AuditPopup}
                    <Modal.Body>
                        <ModalHeader HeaderName={SetRevenueName} isOpenAudit={isOpenAudit} handleAuditModal={handleAuditModal} DeletePopup={DeletePopup} isClosed={onRevenueSave ? onDeleteRevenue : onClose} key={634} Name={'Revenue'} IsDeleteAllowed={IsDeleteAllowed} />
                        {AddNewRevenueCodesModalBody()}
                    </Modal.Body>
                    <ModalFooter isSaved={onRevenueSave ? onDeleteRevenue : onClose} handleSave={handleSaveRevenue} UpdatedDate={mainRevenueModal.UpdatedDate} UpdatedBy={mainRevenueModal.UpdatedBy} ID={RevenueCodes} IsEditAllowed={IsEditAllowed} />
                </Modal>
            }

        </React.Fragment>
    )
}

export default AddNewRevenueCodes